module.exports = __webpack_public_path__ + "assets/img/banner.8e75c67e.jpg";